import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

// Placeholder temporal: de momento solo muestra los datos capturados del invitado, hasta que
// exista un flujo real de solicitud de cuenta. Presentacional (sin Redux) porque solo lo abre
// GuestTopBar — a diferencia de GuestSessionExpiredModal, que sí vive en Redux porque lo puede
// abrir un interceptor de respuesta desde cualquier punto de la app.
const GuestRequestAccountModal = ({ active, onClose, clientName, name, email }) => (
  <Modal
    id="guestRequestAccount"
    title={I18n.t('guest.requestAccountModal.title')}
    active={active}
    children={
      <>
        <Paragraph className="text-grey-700">{I18n.t('guest.requestAccountModal.body')}</Paragraph>
        <dl className="guest-request-account-details">
          <dt>{I18n.t('guest.requestAccountModal.clientLabel')}</dt>
          <dd>{clientName}</dd>
          <dt>{I18n.t('guest.requestAccountModal.nameLabel')}</dt>
          <dd>{name}</dd>
          <dt>{I18n.t('guest.requestAccountModal.emailLabel')}</dt>
          <dd>{email}</dd>
        </dl>
      </>
    }
    footer={
      <Button id="guestRequestAccountCloseButton" onClick={onClose} primary label={I18n.t('guest.requestAccountModal.close')}></Button>
    }
  ></Modal>
);

GuestRequestAccountModal.propTypes = {
  active: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  clientName: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string
};

export default GuestRequestAccountModal;
